// FreeExtensionApproval.js
// Drop in: src/pages/Admin/FreeExtensionApproval.js

// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Button,
//   Tag,
//   Card,
//   Layout,
//   Typography,
//   Space,
//   message,
//   Modal,
//   Image,
//   Input,
//   Tooltip,
// } from "antd";
// import {
//   CheckOutlined,
//   CloseOutlined,
//   EyeOutlined,
//   MenuOutlined,
// } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../../Config";
// import Sidebar from "../../Components/Sidebar";

// const { Header } = Layout;
// const { Text } = Typography;
// const { TextArea } = Input;

// const FreeExtensionApproval = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   // ── Proof viewer modal ──────────────────────────────────
//   const [proofModal, setProofModal] = useState(false);
//   const [selectedRequest, setSelectedRequest] = useState(null);

//   // ── Reject modal ────────────────────────────────────────
//   const [rejectModal, setRejectModal] = useState(false);
//   const [rejectTarget, setRejectTarget] = useState(null);
//   const [rejectNote, setRejectNote] = useState("");
//   const [rejectLoading, setRejectLoading] = useState(false);

//   // ── Approve loading ─────────────────────────────────────
//   const [approvingId, setApprovingId] = useState(null);

//   const token = sessionStorage.getItem("token");

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

// useEffect(() => {
//   fetchPending();

// }, []);

//   // ── API calls ───────────────────────────────────────────
//   const fetchPending = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${BASE_URL}/free-extension/admin/pending`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setData(res.data.data || []);
//     } catch {
//       message.error("Failed to load free extension requests");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApprove = async (record) => {
//     try {
//       setApprovingId(record._id);
//       await axios.put(
//         `${BASE_URL}/free-extension/admin/approve/${record._id}`,
//         { adminNote: "Approved by admin" },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       message.success(`Approved — ${record.extensionDays} days added for user.`);
//       fetchPending();
//     } catch (err) {
//       message.error(err.response?.data?.error ?? "Approval failed");
//     } finally {
//       setApprovingId(null);
//     }
//   };

//   const openRejectModal = (record) => {
//     setRejectTarget(record);
//     setRejectNote("");
//     setRejectModal(true);
//   };

//   const handleReject = async () => {
//     if (!rejectNote.trim()) {
//       message.warning("Please enter a rejection reason.");
//       return;
//     }
//     try {
//       setRejectLoading(true);
//       await axios.put(
//         `${BASE_URL}/free-extension/admin/reject/${rejectTarget._id}`,
//         { adminNote: rejectNote },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       message.success("Request rejected.");
//       setRejectModal(false);
//       fetchPending();
//     } catch (err) {
//       message.error(err.response?.data?.error ?? "Rejection failed");
//     } finally {
//       setRejectLoading(false);
//     }
//   };

//   const openProofModal = (record) => {
//     setSelectedRequest(record);
//     setProofModal(true);
//   };

//   // ── Helpers ─────────────────────────────────────────────
//   const planColor = {
//     "basic-1": "green",
//     "basic-2": "blue",
//     standard: "purple",
//     premium: "gold",
//   };

//   const tierLabel = {
//     p1: "≤20 links",
//     p2: "≤50 links",
//     p3: "≤100 links",
//     p4: "≤200 links",
//   };

//   // ── Table columns ───────────────────────────────────────
//   const columns = [
//     {
//       title: "User",
//       render: (_, r) => (
//         <>
//           <div><strong>{r.userId}</strong></div>
//           <small style={{ color: "#888" }}>
//             Submitted: {new Date(r.createdAt).toLocaleDateString()}
//           </small>
//         </>
//       ),
//     },
//     {
//       title: "Plan",
//       dataIndex: "plan",
//       render: (plan) => (
//         <Tag color={planColor[plan]}>{plan?.toUpperCase()}</Tag>
//       ),
//       filters: [
//         { text: "Basic-1", value: "basic-1" },
//         { text: "Basic-2", value: "basic-2" },
//         { text: "Standard", value: "standard" },
//         { text: "Premium", value: "premium" },
//       ],
//       onFilter: (value, record) => record.plan === value,
//     },
//     {
//       title: "Tier",
//       dataIndex: "mediaLinkTier",
//       render: (tier) => <Tag color="cyan">{tierLabel[tier]}</Tag>,
//     },
//     {
//       title: "Extension",
//       dataIndex: "extensionDays",
//       render: (days, r) => (
//         <Space direction="vertical" size={0}>
//           <Tag color="blue">+{days} days</Tag>
//           {r.withLogo && <Tag color="purple">With Logo</Tag>}
//         </Space>
//       ),
//       sorter: (a, b) => a.extensionDays - b.extensionDays,
//     },
//     {
//       title: "Platforms",
//       dataIndex: "platforms",
//       render: (platforms) => (
//         <Space wrap>
//           {platforms?.map((p) => (
//             <Tag key={p}>{p}</Tag>
//           ))}
//         </Space>
//       ),
//     },
//     {
//       title: "Sharing Proof",
//       render: (_, r) => (
//         <Space direction="vertical" size={4}>
//           {/* Hashtags */}
//           <div style={{ fontSize: 12 }}>
//             {r.sharingHashtags?.map((h) => (
//               <Tag key={h} color="blue" style={{ fontSize: 11 }}>{h}</Tag>
//             ))}
//           </div>
//           {/* @yogarefer tag */}
//           <Tag color={r.yogareferTagged ? "green" : "red"} style={{ fontSize: 11 }}>
//             {r.yogareferTagged ? "✓ @yogarefer" : "✗ @yogarefer"}
//           </Tag>
//           {/* Public confirmed */}
//           <Tag color={r.isPublicConfirmed ? "green" : "red"} style={{ fontSize: 11 }}>
//             {r.isPublicConfirmed ? "✓ Public" : "✗ Not confirmed"}
//           </Tag>
//           {/* Shared at */}
//           <div style={{ fontSize: 11, color: "#6b7280" }}>
//             Shared: {r.sharedAt ? new Date(r.sharedAt).toLocaleString() : "—"}
//           </div>
//         </Space>
//       ),
//     },
//     {
//       title: "Screenshots",
//       render: (_, r) => (
//         <Button
//           icon={<EyeOutlined />}
//           size="small"
//           onClick={() => openProofModal(r)}
//         >
//           View ({r.proofImages?.length ?? 0})
//         </Button>
//       ),
//     },
//     {
//       title: "Actions",
//       render: (_, record) => (
//         <Space>
//           <Tooltip title="Approve — adds extension days to all user variations">
//             <Button
//               type="primary"
//               icon={<CheckOutlined />}
//               loading={approvingId === record._id}
//               onClick={() => handleApprove(record)}
//               style={{ background: "#10b981", borderColor: "#10b981" }}
//             >
//               Approve
//             </Button>
//           </Tooltip>
//           <Button
//             danger
//             icon={<CloseOutlined />}
//             onClick={() => openRejectModal(record)}
//           >
//             Reject
//           </Button>
//         </Space>
//       ),
//     },
//   ];

//   // ── Render ──────────────────────────────────────────────
//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//         role="admin"
//       />
//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header className="MainHeader">
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>
//               🎁 Free Extension Requests
//             </Text>
//           </div>
//           <Space>
//             <Tag color="orange" style={{ fontSize: 14, padding: "4px 12px" }}>
//               {data.length} Pending
//             </Tag>
//             <Button onClick={fetchPending}>Refresh</Button>
//           </Space>
//         </Header>

//         <Card style={{ borderRadius: 12 }}>
//           <Table
//             columns={columns}
//             dataSource={data}
//             rowKey="_id"
//             loading={loading}
//             pagination={{ pageSize: 10 }}
//             scroll={{ x: 900 }}
//           />
//         </Card>
//       </Layout>

//       {/* ── Proof Screenshots Modal ───────────────────────── */}
//       <Modal
//         title={`Proof Screenshots — ${selectedRequest?.plan?.toUpperCase()} plan`}
//         open={proofModal}
//         onCancel={() => setProofModal(false)}
//         footer={
//           <Space>
//             <Button
//               type="primary"
//               icon={<CheckOutlined />}
//               loading={approvingId === selectedRequest?._id}
//               onClick={() => {
//                 handleApprove(selectedRequest);
//                 setProofModal(false);
//               }}
//               style={{ background: "#10b981", borderColor: "#10b981" }}
//             >
//               Approve
//             </Button>
//             <Button
//               danger
//               icon={<CloseOutlined />}
//               onClick={() => {
//                 setProofModal(false);
//                 openRejectModal(selectedRequest);
//               }}
//             >
//               Reject
//             </Button>
//           </Space>
//         }
//         width={700}
//         centered
//       >
//         {selectedRequest && (
//           <>
//             {/* Sharing details summary */}
//             <Card
//               size="small"
//               style={{ marginBottom: 16, background: "#f9fafb" }}
//             >
//               <Space direction="vertical" size={6} style={{ width: "100%" }}>
//                 <div>
//                   <Text strong>Hashtags: </Text>
//                   {selectedRequest.sharingHashtags?.map((h) => (
//                     <Tag key={h} color="blue">{h}</Tag>
//                   ))}
//                 </div>
//                 <div>
//                   <Text strong>@yogarefer tagged: </Text>
//                   <Tag color={selectedRequest.yogareferTagged ? "green" : "red"}>
//                     {selectedRequest.yogareferTagged ? "Yes" : "No"}
//                   </Tag>
//                 </div>
//                 <div>
//                   <Text strong>Public confirmed: </Text>
//                   <Tag color={selectedRequest.isPublicConfirmed ? "green" : "red"}>
//                     {selectedRequest.isPublicConfirmed ? "Yes" : "No"}
//                   </Tag>
//                 </div>
//                 <div>
//                   <Text strong>Shared at: </Text>
//                   <Text>{selectedRequest.sharedAt ? new Date(selectedRequest.sharedAt).toLocaleString() : "—"}</Text>
//                 </div>
//                 <div>
//                   <Text strong>Platforms: </Text>
//                   {selectedRequest.platforms?.map((p) => (
//                     <Tag key={p}>{p}</Tag>
//                   ))}
//                 </div>
//                 {selectedRequest.blogUrl && (
//                   <div>
//                     <Text strong>Blog URL: </Text>
//                     <a href={selectedRequest.blogUrl} target="_blank" rel="noreferrer">
//                       {selectedRequest.blogUrl}
//                     </a>
//                   </div>
//                 )}
//                 {selectedRequest.yogaGroups?.length > 0 && (
//                   <div>
//                     <Text strong>Yoga Groups: </Text>
//                     {selectedRequest.yogaGroups.map((g) => (
//                       <Tag key={g}>{g}</Tag>
//                     ))}
//                   </div>
//                 )}
//               </Space>
//             </Card>

//             {/* Screenshots */}
//             <div style={{ fontWeight: 600, marginBottom: 10 }}>
//               Screenshots ({selectedRequest.proofImages?.length}):
//             </div>
//             <Image.PreviewGroup>
//               <Space wrap>
//                 {selectedRequest.proofImages?.map((url, i) => (
//                   <Image
//                     key={i}
//                     src={url}
//                     width={180}
//                     height={180}
//                     style={{ objectFit: "cover", borderRadius: 8, border: "1px solid #e5e7eb" }}
//                   />
//                 ))}
//               </Space>
//             </Image.PreviewGroup>
//           </>
//         )}
//       </Modal>

//       {/* ── Reject Reason Modal ───────────────────────────── */}
//       <Modal
//         title="Reject Request"
//         open={rejectModal}
//         onCancel={() => setRejectModal(false)}
//         footer={
//           <Space>
//             <Button onClick={() => setRejectModal(false)}>Cancel</Button>
//             <Button
//               danger
//               loading={rejectLoading}
//               onClick={handleReject}
//             >
//               Confirm Reject
//             </Button>
//           </Space>
//         }
//         centered
//       >
//         <div style={{ marginBottom: 10, color: "#374151", fontSize: 13 }}>
//           Please provide a reason (shown to the user):
//         </div>
//         <TextArea
//           rows={4}
//           placeholder="e.g. Screenshot doesn't show #YogaRefer hashtag clearly..."
//           value={rejectNote}
//           onChange={(e) => setRejectNote(e.target.value)}
//         />
//       </Modal>
//     </Layout>
//   );
// };

// export default FreeExtensionApproval;

import React, { useEffect, useState } from "react";
import {
  Table, Button, Tag, Card, Layout, Typography,
  Space, message, Modal, Image, Input, Tooltip, Divider,
} from "antd";
import {
  CheckOutlined, CloseOutlined, EyeOutlined,
  MenuOutlined, ReloadOutlined, GiftOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../../Config";
import Sidebar from "../../Components/Sidebar";

const { Header, Content } = Layout;
const { Text } = Typography;
const { TextArea } = Input;

const FreeExtensionApproval = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [proofModal, setProofModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const [rejectModal, setRejectModal] = useState(false);
  const [rejectTarget, setRejectTarget] = useState(null);
  const [rejectNote, setRejectNote] = useState("");
  const [rejectLoading, setRejectLoading] = useState(false);

  const [approvingId, setApprovingId] = useState(null);

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => { fetchPending(); }, []);

  const fetchPending = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/free-extension/admin/pending`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data.data || []);
    } catch {
      message.error("Failed to load free extension requests");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (record) => {
    try {
      setApprovingId(record._id);
      await axios.put(
        `${BASE_URL}/free-extension/admin/approve/${record._id}`,
        { adminNote: "Approved by admin" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success(`Approved — ${record.extensionDays} days added for user.`);
      fetchPending();
    } catch (err) {
      message.error(err.response?.data?.error ?? "Approval failed");
    } finally {
      setApprovingId(null);
    }
  };

  const openRejectModal = (record) => {
    setRejectTarget(record);
    setRejectNote("");
    setRejectModal(true);
  };

  const handleReject = async () => {
    if (!rejectNote.trim()) {
      message.warning("Please enter a rejection reason.");
      return;
    }
    try {
      setRejectLoading(true);
      await axios.put(
        `${BASE_URL}/free-extension/admin/reject/${rejectTarget._id}`,
        { adminNote: rejectNote },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success("Request rejected.");
      setRejectModal(false);
      fetchPending();
    } catch (err) {
      message.error(err.response?.data?.error ?? "Rejection failed");
    } finally {
      setRejectLoading(false);
    }
  };

  const openProofModal = (record) => {
    setSelectedRequest(record);
    setProofModal(true);
  };

  // ── Helpers ─────────────────────────────────────────────
  const planColor = {
    "basic-1": "green", "basic-2": "blue",
    standard: "purple", premium: "gold",
    "monthly-100": "magenta",
  };
  const tierLabel = {
    p1: "≤20 links", p2: "≤50 links",
    p3: "≤100 links", p4: "≤200 links",
  };

  // ── Desktop columns ──────────────────────────────────────
  const columns = [
    {
      title: "User",
      render: (_, r) => (
        <>
          <div><strong>{r.userId}</strong></div>
          <small style={{ color: "#888" }}>
            {new Date(r.createdAt).toLocaleDateString()}
          </small>
        </>
      ),
    },
    {
      title: "Plan",
      dataIndex: "plan",
      render: (plan) => <Tag color={planColor[plan]}>{plan?.toUpperCase()}</Tag>,
      filters: [
        { text: "Basic-1", value: "basic-1" },
        { text: "Basic-2", value: "basic-2" },
        { text: "Standard", value: "standard" },
        { text: "Premium", value: "premium" },
        { text: "Monthly special (100+)", value: "monthly-100" },
      ],
      onFilter: (value, record) => record.plan === value,
    },
    {
      title: "Tier",
      dataIndex: "mediaLinkTier",
      render: (tier) => <Tag color="cyan">{tierLabel[tier]}</Tag>,
    },
    {
      title: "Extension",
      dataIndex: "extensionDays",
      render: (days, r) => (
        <Space direction="vertical" size={0}>
          <Tag color="blue">
            {r.plan === "monthly-100" ? "+1 month +1 image" : `+${days} days`}
          </Tag>
          {r.withLogo && <Tag color="purple">With Logo</Tag>}
        </Space>
      ),
      sorter: (a, b) => a.extensionDays - b.extensionDays,
    },
    {
      title: "Platforms",
      dataIndex: "platforms",
      render: (platforms) => (
        <Space wrap>
          {platforms?.map((p) => <Tag key={p}>{p}</Tag>)}
        </Space>
      ),
    },
    {
      title: "Sharing Proof",
      render: (_, r) => (
        <Space direction="vertical" size={4}>
          <div style={{ fontSize: 12 }}>
            {r.sharingHashtags?.map((h) => (
              <Tag key={h} color="blue" style={{ fontSize: 11 }}>{h}</Tag>
            ))}
          </div>
          <Tag color={r.yogareferTagged ? "green" : "red"} style={{ fontSize: 11 }}>
            {r.yogareferTagged ? "✓ @yogarefer" : "✗ @yogarefer"}
          </Tag>
          <Tag color={r.isPublicConfirmed ? "green" : "red"} style={{ fontSize: 11 }}>
            {r.isPublicConfirmed ? "✓ Public" : "✗ Not confirmed"}
          </Tag>
          <div style={{ fontSize: 11, color: "#6b7280" }}>
            Shared: {r.sharedAt ? new Date(r.sharedAt).toLocaleString() : "—"}
          </div>
        </Space>
      ),
    },
    {
      title: "Screenshots",
      render: (_, r) => (
        <Button icon={<EyeOutlined />} size="small" onClick={() => openProofModal(r)}>
          View ({r.proofImages?.length ?? 0})
        </Button>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Approve — adds extension days to all user variations">
            <Button
              type="primary"
              icon={<CheckOutlined />}
              loading={approvingId === record._id}
              onClick={() => handleApprove(record)}
              style={{ background: "#10b981", borderColor: "#10b981" }}
            >
              Approve
            </Button>
          </Tooltip>
          <Button danger icon={<CloseOutlined />} onClick={() => openRejectModal(record)}>
            Reject
          </Button>
        </Space>
      ),
    },
  ];

  // ── Mobile request card ──────────────────────────────────
  const MobileCard = ({ record }) => (
    <Card
      style={{ marginBottom: 12, borderRadius: 12, boxShadow: "0 1px 6px rgba(0,0,0,0.08)" }}
      bodyStyle={{ padding: "14px 16px" }}
    >
      {/* Row 1 – User + Plan */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
        <div style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
          <Text strong style={{ fontSize: 14, display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {record.userId}
          </Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {new Date(record.createdAt).toLocaleDateString()}
          </Text>
        </div>
        <Tag color={planColor[record.plan]}>{record.plan?.toUpperCase()}</Tag>
      </div>

      {/* Row 2 – Tier / Extension / Logo */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
        <Tag color="cyan">{tierLabel[record.mediaLinkTier]}</Tag>
        <Tag color="blue">+{record.extensionDays} days</Tag>
        {record.withLogo && <Tag color="purple">With Logo</Tag>}
        {record.platforms?.map((p) => <Tag key={p}>{p}</Tag>)}
      </div>

      {/* Row 3 – Sharing proof pills */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
        {record.sharingHashtags?.map((h) => (
          <Tag key={h} color="blue" style={{ fontSize: 11 }}>{h}</Tag>
        ))}
        <Tag color={record.yogareferTagged ? "green" : "red"} style={{ fontSize: 11 }}>
          {record.yogareferTagged ? "✓ @yogarefer" : "✗ @yogarefer"}
        </Tag>
        <Tag color={record.isPublicConfirmed ? "green" : "red"} style={{ fontSize: 11 }}>
          {record.isPublicConfirmed ? "✓ Public" : "✗ Not public"}
        </Tag>
      </div>

      <Text type="secondary" style={{ fontSize: 11, display: "block", marginBottom: 10 }}>
        Shared: {record.sharedAt ? new Date(record.sharedAt).toLocaleString() : "—"}
      </Text>

      {/* Row 4 – Action buttons */}
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          icon={<EyeOutlined />}
          onClick={() => openProofModal(record)}
          style={{ flex: "1 1 0" }}
        >
          Screenshots ({record.proofImages?.length ?? 0})
        </Button>
        <Button
          type="primary"
          icon={<CheckOutlined />}
          loading={approvingId === record._id}
          onClick={() => handleApprove(record)}
          style={{ flex: "1 1 0", background: "#10b981", borderColor: "#10b981" }}
        >
          Approve
        </Button>
        <Button
          danger
          icon={<CloseOutlined />}
          onClick={() => openRejectModal(record)}
          style={{ flex: "1 1 0" }}
        >
          Reject
        </Button>
      </div>
    </Card>
  );

  const sidebarWidth = isMobile ? 0 : collapsed ? 0 : 240;

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />

      <Layout style={{ marginLeft: sidebarWidth, transition: "margin-left 0.3s" }}>

        {/* ── Header ── */}
        <Header
          style={{
            background: "#fff",
            padding: isMobile ? "0 12px" : "0 24px",
            height: "auto",
            minHeight: 64,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            borderBottom: "1px solid #f0f0f0",
            position: "sticky",
            top: 0,
            zIndex: 100,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          {/* Hamburger + Title */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, flex: "1 1 auto", minWidth: 0 }}>
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setMobileOpen(true)}
                style={{ fontSize: 18, padding: 0, flexShrink: 0 }}
              />
            )}
            <Text
              strong
              style={{
                fontSize: isMobile ? 15 : 20,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
               Free Extension Requests
            </Text>
          </div>

          {/* Right controls */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
              width: isMobile ? "100%" : "auto",
              paddingBottom: isMobile ? 8 : 0,
            }}
          >
            <Tag
              color="orange"
              style={{ fontSize: 13, padding: "4px 10px", flex: isMobile ? "1 1 0" : "none", textAlign: "center" }}
            >
              {data.length} Pending
            </Tag>
            <Button
              icon={<ReloadOutlined />}
              onClick={fetchPending}
              loading={loading}
              style={{ flex: isMobile ? "1 1 0" : "none" }}
            >
              Refresh
            </Button>
          </div>
        </Header>

        {/* ── Content ── */}
        <Content style={{ padding: isMobile ? "12px 10px" : "20px 24px" }}>
          {isMobile ? (
            loading ? (
              <div style={{ textAlign: "center", padding: 40 }}>
                <Text type="secondary">Loading…</Text>
              </div>
            ) : data.length === 0 ? (
              <Card style={{ borderRadius: 12, textAlign: "center" }}>
                <Text type="secondary">No pending requests.</Text>
              </Card>
            ) : (
              data.map((record) => (
                <MobileCard key={record._id} record={record} />
              ))
            )
          ) : (
            <Card style={{ borderRadius: 12 }}>
              <Table
                columns={columns}
                dataSource={data}
                rowKey="_id"
                loading={loading}
                pagination={{ pageSize: 10 }}
                scroll={{ x: 900 }}
              />
            </Card>
          )}
        </Content>
      </Layout>

      {/* ── Proof Screenshots Modal ── */}
      <Modal
        title={`Proof Screenshots — ${selectedRequest?.plan?.toUpperCase()} plan`}
        open={proofModal}
        onCancel={() => setProofModal(false)}
        footer={
          <Space style={{ width: "100%", justifyContent: isMobile ? "stretch" : "flex-end" }}>
            <Button
              type="primary"
              icon={<CheckOutlined />}
              loading={approvingId === selectedRequest?._id}
              onClick={() => { handleApprove(selectedRequest); setProofModal(false); }}
              style={{ background: "#10b981", borderColor: "#10b981", flex: isMobile ? 1 : "none" }}
            >
              Approve
            </Button>
            <Button
              danger
              icon={<CloseOutlined />}
              onClick={() => { setProofModal(false); openRejectModal(selectedRequest); }}
              style={{ flex: isMobile ? 1 : "none" }}
            >
              Reject
            </Button>
          </Space>
        }
        width={isMobile ? "95vw" : 700}
        style={isMobile ? { top: 16 } : {}}
        centered={!isMobile}
      >
        {selectedRequest && (
          <>
            <Card size="small" style={{ marginBottom: 16, background: "#f9fafb" }}>
              <Space direction="vertical" size={6} style={{ width: "100%" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4, alignItems: "center" }}>
                  <Text strong style={{ marginRight: 4 }}>Hashtags:</Text>
                  {selectedRequest.sharingHashtags?.map((h) => (
                    <Tag key={h} color="blue">{h}</Tag>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <div>
                    <Text strong>@yogarefer: </Text>
                    <Tag color={selectedRequest.yogareferTagged ? "green" : "red"}>
                      {selectedRequest.yogareferTagged ? "Yes" : "No"}
                    </Tag>
                  </div>
                  <div>
                    <Text strong>Public: </Text>
                    <Tag color={selectedRequest.isPublicConfirmed ? "green" : "red"}>
                      {selectedRequest.isPublicConfirmed ? "Yes" : "No"}
                    </Tag>
                  </div>
                </div>
                <div>
                  <Text strong>Shared at: </Text>
                  <Text>{selectedRequest.sharedAt ? new Date(selectedRequest.sharedAt).toLocaleString() : "—"}</Text>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4, alignItems: "center" }}>
                  <Text strong style={{ marginRight: 4 }}>Platforms:</Text>
                  {selectedRequest.platforms?.map((p) => <Tag key={p}>{p}</Tag>)}
                </div>
                {selectedRequest.blogUrl && (
                  <div>
                    <Text strong>Blog URL: </Text>
                    <a href={selectedRequest.blogUrl} target="_blank" rel="noreferrer"
                      style={{ wordBreak: "break-all" }}>
                      {selectedRequest.blogUrl}
                    </a>
                  </div>
                )}
                {selectedRequest.yogaGroups?.length > 0 && (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 4, alignItems: "center" }}>
                    <Text strong style={{ marginRight: 4 }}>Yoga Groups:</Text>
                    {selectedRequest.yogaGroups.map((g) => <Tag key={g}>{g}</Tag>)}
                  </div>
                )}
              </Space>
            </Card>

            <div style={{ fontWeight: 600, marginBottom: 10 }}>
              Screenshots ({selectedRequest.proofImages?.length}):
            </div>
            <Image.PreviewGroup>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {selectedRequest.proofImages?.map((url, i) => (
                  <Image
                    key={i}
                    src={url}
                    width={isMobile ? "calc(50% - 4px)" : 180}
                    height={isMobile ? 150 : 180}
                    style={{ objectFit: "cover", borderRadius: 8, border: "1px solid #e5e7eb" }}
                  />
                ))}
              </div>
            </Image.PreviewGroup>
          </>
        )}
      </Modal>

      {/* ── Reject Reason Modal ── */}
      <Modal
        title="Reject Request"
        open={rejectModal}
        onCancel={() => setRejectModal(false)}
        width={isMobile ? "92vw" : 480}
        style={isMobile ? { top: 24 } : {}}
        centered={!isMobile}
        footer={
          <Space style={{ width: "100%", justifyContent: isMobile ? "stretch" : "flex-end" }}>
            <Button
              onClick={() => setRejectModal(false)}
              style={{ flex: isMobile ? 1 : "none" }}
            >
              Cancel
            </Button>
            <Button
              danger
              loading={rejectLoading}
              onClick={handleReject}
              style={{ flex: isMobile ? 1 : "none" }}
            >
              Confirm Reject
            </Button>
          </Space>
        }
      >
        <div style={{ marginBottom: 10, color: "#374151", fontSize: 13 }}>
          Please provide a reason (shown to the user):
        </div>
        <TextArea
          rows={4}
          placeholder="e.g. Screenshot doesn't show #YogaRefer hashtag clearly..."
          value={rejectNote}
          onChange={(e) => setRejectNote(e.target.value)}
        />
      </Modal>
    </Layout>
  );
};

export default FreeExtensionApproval;